import MuiDialog, { type DialogProps } from '@mui/material/Dialog';

export type { DialogProps };
export { default as DialogTitle } from '@mui/material/DialogTitle';
export type { DialogTitleProps } from '@mui/material/DialogTitle';
export { default as DialogContent } from '@mui/material/DialogContent';
export type { DialogContentProps } from '@mui/material/DialogContent';
export { default as DialogContentText } from '@mui/material/DialogContentText';
export type { DialogContentTextProps } from '@mui/material/DialogContentText';
export { default as DialogActions } from '@mui/material/DialogActions';
export type { DialogActionsProps } from '@mui/material/DialogActions';

const Dialog = (props: DialogProps) => <MuiDialog fullWidth maxWidth="sm" {...props} />;

export default Dialog;
